import { Tile } from '../tiles';
import { deal } from '../wall';
import { GameState, PlayerState } from './types';

export function sortHand(hand: Tile[]): Tile[] {
  return hand.slice().sort((a, b) => a - b);
}

export interface InitOptions {
  seed: string;
  dealer?: number;
  roundWind?: Tile;
  points?: number[];
}

/** 1국 초기 상태. 배패 13×4 + 사패 14 + 라이브 70, 도라표시 1장 공개. */
export function initHand(opts: InitOptions): GameState {
  const dealer = opts.dealer ?? 0;
  const roundWind = opts.roundWind ?? 27;
  const startPoints = opts.points ?? [25000, 25000, 25000, 25000];

  const d = deal(opts.seed); // hands: 13×4, wall: 84
  const deadWall = d.wall.slice(d.wall.length - 14); // 마지막 14장 = 왕패
  const wall = d.wall.slice(0, d.wall.length - 14);  // 라이브 70장
  const doraIndicators = [deadWall[0]];

  const players: PlayerState[] = d.hands.map((hand, i) => ({
    hand: sortHand(hand),
    discards: [],
    riichi: false,
    riichiIndex: null,
    points: startPoints[i],
    seat: (27 + ((i - dealer + 4) % 4)) as Tile, // dealer=東(27)
  }));

  return {
    players,
    wall,
    deadWall,
    doraIndicators,
    roundWind,
    dealer,
    turn: dealer,
    phase: 'draw',
    drawn: null,
    lastDiscard: null,
    responders: [],
    riichiSticks: 0,
    result: null,
    seed: opts.seed,
  };
}
